import { settingsRepository } from '@webapp/core/data-access/repositories/SettingsRepository'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'

const base = ['settings']

export const settingsQueryConfig = {
  getIntegrationStatus: () => ({
    queryKey: buildQueryKey([...base, 'integrationStatus']),
    queryFn: () => settingsRepository.getIntegrationStatus(),
  }),
}
